import { loader } from "fumadocs-core/source";
import { docs, marketing, blog, feature, audience } from "./collections";

export const docsSource = loader({ source: docs.toFumadocsSource(), baseUrl: "/docs" });
export const marketingSource = loader({
  source: marketing.toFumadocsSource(),
  baseUrl: "/compare",
});
export const blogSource = loader({ source: blog.toFumadocsSource(), baseUrl: "/blog" });
export const featureSource = loader({ source: feature.toFumadocsSource(), baseUrl: "/feature" });
export const audienceSource = loader({ source: audience.toFumadocsSource(), baseUrl: "/audience" });
